import React, { useState, memo, useCallback } from 'react';
import Sidebar from './Sidebar';
import { Outlet } from "react-router-dom";

const MainLayout = () => {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    return localStorage.getItem("sidebarCollapsed") === "true";
  });

  const handleCollapse = useCallback((value) => {
    setIsCollapsed(value);
    localStorage.setItem("sidebarCollapsed", value);
  }, []);

  return (
    <div className="flex h-screen overflow-hidden bg-background">

      {/* SIDEBAR */}
      <div
        className={`
          transition-all duration-300 overflow-hidden
          w-0
          ${isCollapsed ? "lg:w-20" : "lg:w-60"}
        `}
      >
        <Sidebar isCollapsed={isCollapsed} onCollapse={handleCollapse} />
      </div>

      {/* MAIN CONTENT */}
      <main className="flex-1 overflow-hidden relative">
        {/* {isCollapsed && (
          <button
            onClick={() => handleCollapse(false)}
            className="absolute top-4 left-4 z-50 bg-white border rounded p-2 shadow"
          >
          
          </button>
        )} */}
        <div className="pt-16 lg:pt-0 lg:pl-0">
          <Outlet />
        </div>
      </main>

    </div>
  );
};

export default memo(MainLayout);